<template>
  <v-app>
      <v-container class="mt-5">
          <v-row class="justify-content-center mt-5">
            <v-col cols="12" lg="2" class="text-right text-bold">
                Fecha del Gastos
            </v-col>  
            <v-col cols="12" lg="4">
                <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
                >
                <template v-slot:activator="{ on }">
                    <v-text-field
                    v-model="compro.fecha"
                    label="Fecha de comprobación"
                    append-icon="mdi-calendar"
                    readonly
                    v-on="on"
                    ></v-text-field>
                </template>
                <v-date-picker v-model="compro.fecha" @input="menu2 = false"></v-date-picker>
                </v-menu>
            </v-col>
          
              <v-col lg="2" class="text-right text-bold">País del gasto</v-col>
              <v-col lg="4">
                  <v-select
                  append-icon="mdi-earth"
                  :items="paises"
                  v-model="compro.pais">

                  </v-select>
              </v-col>

              <v-col lg="2" class="text-right text-bold">Tipo de Gasto</v-col>
              <v-col lg="4">
                  <v-select
                  append-icon="mdi-airplane"
                  v-model="compro.concepto"
                  :items="tpo_gastos">

                  </v-select>
              </v-col>

              <v-col lg="2" class="text-right text-bold">Nombre del establecimiento</v-col>
              <v-col lg="4">
                  <v-text-field
                  v-model="compro.establecimiento"
                  append-icon="mdi-cart">

                  </v-text-field>
              </v-col>

              <v-col lg="2" class="text-right text-bold">ID Fiscal</v-col>
              <v-col lg="4">
                  <v-text-field
                  append-icon="mdi-numeric"
                  v-model="compro.id_fiscal">

                  </v-text-field>
              </v-col>

              <v-col lg="2" class="text-right text-bold">Monto</v-col>
              <v-col lg="4">
                  <v-text-field
                  v-model="compro.importe"
                  append-icon="mdi-currency-usd">

                  </v-text-field>
              </v-col>
 
              <v-col lg="2" class="text-right text-bold">Impuesto</v-col>
              <v-col lg="4">
                  <v-text-field
                  v-model="compro.impuesto"
                  append-icon="mdi-currency-usd">

                  </v-text-field>
              </v-col>

              <v-col lg="2" class="text-right text-bold">Descripción</v-col>
              <v-col lg="4">
                  <v-text-field
                  v-model="compro.descripcion"
                  append-icon="mdi-card-text">

                  </v-text-field>
              </v-col>

              <v-col lg="2" class="text-right text-bold">Tipo de Depósito</v-col>
              <v-col lg="4">
                  <v-select
                  :items="tipos"
                  v-model="compro.tipo"
                  >

                  </v-select>
              </v-col>

              <v-col lg="2" class="text-right text-bold">Nombre reporte de gastos</v-col>
              <v-col lg="4">
                  <v-select
                  :items="grupos"
                  v-model="compro.grupo_id"
                  item-text="name"
                  item-value="id"
                  >
                  </v-select>
                  <v-btn @click="dialog=true">Añadir Grupo</v-btn>
              </v-col>
          </v-row>
          <v-row class="justify-content-start">
              <v-col lg="2" class="text-right text-bold">Archivos Adjuntos</v-col>
              <v-col lg="4">
                  <v-file-input
                  multiple
                  v-model="file">
                  </v-file-input>
              </v-col>
          </v-row>  
            <v-row class="justify-content-center">
              <v-col lg="6">
                  <v-row class="justify-content-between">
                        <v-btn color="success" @click="setData">
                      Agregar 
                  </v-btn>
                  <v-btn color="error">
                      Cancelar
                  </v-btn>
                  </v-row>
                
              </v-col>
            
          </v-row>                                                            
      </v-container>
        <v-dialog v-model="dialog" max-width="500px">
          <v-card>
            <v-card-title>
              <span class="headline">Añadir Grupo</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="4" lg="12" class="text-left h5">
                      Nombre
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="12">
                    <!--<v-text-field v-model="eeditedItem.Tipo" label="Tipo"></v-text-field>-->
                     <v-text-field
                     v-model="grupo.name">

                     </v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                    <v-col lg="12" class="text-center">
                        <v-btn color="success" @click="setGrupo">Guardar</v-btn>
                    </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
  </v-app>
</template>

<script>
import axios from 'axios'
import router from '../../router/index.js'

export default {
    data(){
        return {
            grupo: {name: '',
            id_user: 0},

            grupos: [],
            dialog: false,
            file: null,
            compro: {
                tipo: '',
                fecha: '',
                pais: '',
                establecimiento: '',
                id_fiscal: '',
                importe: '',
                impuesto: '',
                descripcion: ''
            },
            tipos: [
                "Anticipo","Comprobacion"
            ],
            menu2: null,
            date: null,
            paises: [
                'México',
                'Argentina',
                'Brasil',
                'Ecuador'
            ],
            tpo_gastos:[
                'Avion',
                'Hotel',
                'Comida',
                'Transporte'
            ]
        }
    },
    methods: {
        setData: async function(){
            let datos=new FormData()
            for(let x in this.file)
            {
                datos.append('archivos',this.file[x])
            }
            
            /*tipo: '',
                fecha: '',
                pais: '',
                establecimiento: '',
                id_fiscal: '',
                importe: '',
                impuesto: '',
                descripcion: ''*/
            datos.append('tipo',this.compro.tipo)
            datos.append('pais',this.compro.pais)
            datos.append('establecimiento',this.compro.establecimiento)
            datos.append('id_fiscal',this.compro.id_fiscal)
            datos.append('importe',this.compro.importe)
            datos.append('impuesto',this.compro.impuesto)
            datos.append('descripcion',this.compro.descripcion)
            datos.append('fecha',this.compro.fecha)
            datos.append('concepto',this.compro.concepto)
            datos.append('grupo_id',this.compro.grupo_id)

            await axios.put('https://127.0.0.1:3000/comprobacion',datos)

            this.$router.push('/Comprobaciones/Proceso')

        },
        setGrupo: async function(){
            try {
                 await axios.put('https://127.0.0.1:3000/grupo/',this.grupo)
                
                 await this.getGrupos()
                  this.dialog=false

            } catch (error) {
                //console.log(error)
                this.dialog=false
                return error;
            }
           
        },
        getGrupos: async function(){
            let {data} = await axios.get('https://127.0.0.1:3000/grupo/')
            this.grupos=data
        }
    },
    mounted(){
        //Config for axios
        axios.defaults.headers.common['access-token'] = this.$store.state.token;

        axios.interceptors.response.use(function (response){
            //console.log(response.data.message);
            if (response.data.message == 'Token inválida') {
                router.push({name: 'login', params: {errorToken: 'true'}});
            }else{
                return response;
            }
        });
        //End config for axios

        this.getGrupos()
    }
}
</script>

<style>
    .text-bold{
        font-weight:  bolder
    }

    .v-application .success{
        background-color: #2F2E2E !important;
    }
</style>